import { createSelector } from "reselect"
import { get } from "lodash"
import { computeEditingFilter } from "helpers/filters"
import { filterSupportsContribution } from "helpers/segments"
import { createEffectiveFilterScopeSelectors, parseFilterScope } from "helpers/filter-scope"
import { computeChipSecuritiesIds } from "helpers/filters/chips"
import { computeFilterOns } from "helpers/filters/filter-ons"
import { classificationsMap, computeClassifications } from "helpers/classification"
import { computeSecuritiesDescriptors } from "helpers/securities"
import { getTagCategories, getAttributeCategories, getAssetType } from "modules/portfolio-root/selectors"
import { getViewType, getIsActive } from "modules/portfolio-root/selectors/portfolios"
import { getSelectedDate } from "selectors/dates"

export const getPortfolioFilters = state => get(state, "global.data.portfolioFilters.data")
const getEditing = state => get(state, "modules.analyzeFactors.editingFilter")
const getRawClassifications = (state) => get(state, "global.data.classifications.data.classifications")
export const getFilter = state => get(state, "modules.analyzeFactors.filter")
export const getClassificationsValues = (state) => get(state, "global.data.classificationsValues.data")
const getPortfolioSecuritiesDescriptors = (state) => get(state, "global.data.portfolioSecuritiesDescriptors.data")
export const getNormalization = state => get(state, "modules.analyzeFactors.normalization")
export const getFilterScope = state => parseFilterScope(get(state, "modules.analyzeFactors.filterScope"))

export const { getEffectiveFilterScope, getEffectiveNormalization } = createEffectiveFilterScopeSelectors({
  getFilterScope,
  getIsActive,
  getFilter,
  getNormalization,
})

export const getSecuritiesDescriptors = createSelector(
  [getPortfolioSecuritiesDescriptors],
  computeSecuritiesDescriptors,
)

export const getChipSecuritiesIds = createSelector(
  [getFilter],
  computeChipSecuritiesIds,
)

export const getClassifications = createSelector(
  [getRawClassifications, getSelectedDate],
  computeClassifications,
)

export const getFilterOns = createSelector(
  [getViewType, getPortfolioFilters, getFilter, getEditing, getTagCategories, getClassifications, getClassificationsValues, getAttributeCategories, getAssetType, getEffectiveNormalization],
  computeFilterOns,
)

export const getEditingFilter = createSelector(
  [getFilter, getEditing, getFilterOns, getSecuritiesDescriptors],
  computeEditingFilter,
)

export const getClassificationsTiers = createSelector(
  [getRawClassifications, getSelectedDate],
  classificationsMap,
)

export const getHasUnsupportedContributionFilter = createSelector(
  [getFilter, getIsActive],
  (filter, isActive) => !filterSupportsContribution(filter, isActive),
)
